<template>
  <div :id="id" class="box">
    <div v-if="id!=='1'">
      <div class="pine"></div>
      <div class="box-wrap">
        <div class="close" @click="closeClick">X</div>
        <div class="area" v-if="id==4" @click="flyReservoir">
          <div class="area-title fontColor">{{ title }}</div>
        </div>
        <div class="area" @click="flyReservoir">
          <div class="area-title fontColor">{{ title }}</div>
        </div>


        <div v-if="id=='4'" class="content">
          <div class="data-li">
            <div class="data-label textColor">所属水系：</div>
            <div class="data-value">
              <span class="label-num yellowColor">黄河支流</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">流域面积：</div>
            <div class="data-value">
              <span class="label-num yellowColor">3294.0</span>
              <span class="label-unit textColor">平方公里</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">全长：</div>
            <div class="data-value">
              <span class="label-num yellowColor">140.0</span>
              <span class="label-unit textColor">公里</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">河道平均比降：</div>
            <div class="data-value">
              <span class="label-num yellowColor">3.87</span>
              <span class="label-unit textColor">‰</span>
            </div>
          </div>
          <div class="data-label textColor" style="color: red">暴雨中心：</div>
          <div class="data-li">
            <div class="data-label textColor">降雨日期：</div>
            <div class="data-value">
              <span class="label-unit textColor" style="color: red">2023年8月1日</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">最大小时降雨量：</div>
            <div class="data-value">
              <span class="label-num yellowColor" style="color: red">78</span>
              <span class="label-unit textColor" style="color: red">mm</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">流量：</div>
            <div class="data-value">
              <span class="label-num yellowColor" style="color: red">42</span>
              <span class="label-unit textColor" style="color: red">m3/s</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">降雨等级：</div>
            <div class="data-value">
              <img src="../assets/red.png" alt="" style="height: 30px;width: 30px"/>
            </div>
          </div>

        </div>

        <div v-if="id=='2'" class="content">
          <div class="data-li">
            <div class="data-label textColor">观察时间：</div>
            <div class="data-value">
              <span class="label-num yellowColor">{{today}}</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">深度：</div>
            <div class="data-value">
              <span class="label-num yellowColor">2.92</span>
              <span class="label-unit textColor">m</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">本次位移增量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">86.84</span>
              <span class="label-unit textColor">mm</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">累计位移增量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">86.84</span>
              <span class="label-unit textColor">mm</span>
            </div>
          </div>
          <div class="data-li">
            <div class="data-label textColor">变化速率：</div>
            <div class="data-value">
              <span class="label-num yellowColor">84.60</span>
              <span class="label-unit textColor">mm/d</span>
            </div>
          </div>


        </div>


        <div v-if="id=='3'" class="content">


          <div class="data-li">
            <div class="data-label textColor">库内水位：</div>
            <div class="data-value">
              <span class="label-num yellowColor">200</span>
              <span class="label-unit textColor">m</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">降雨量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">10.3</span>
              <span class="label-unit textColor">mm</span>
            </div>
          </div>

          <!-- 下面是新增部分 -->

          <div class="data-li">
            <div class="data-label textColor">入库流量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">520</span>
              <span class="label-unit textColor">m³/s</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">出库流量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">480</span>
              <span class="label-unit textColor">m³/s</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">大坝变形监测：</div>
            <div class="data-value">
              <span class="label-num yellowColor">1.3</span>
              <span class="label-unit textColor">mm</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">渗流量：</div>
            <div class="data-value">
              <span class="label-num yellowColor">12.6</span>
              <span class="label-unit textColor">L/min</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">坝体温度：</div>
            <div class="data-value">
              <span class="label-num yellowColor">18.2</span>
              <span class="label-unit textColor">℃</span>
            </div>
          </div>

          <div class="data-li">
            <div class="data-label textColor">设备在线率：</div>
            <div class="data-value">
              <span class="label-num yellowColor">99.2</span>
              <span class="label-unit textColor">%</span>
            </div>
          </div>

        </div>

      </div>
    </div>


    <div v-if="id=='1'" class="data-li">
      <div class="pine"></div>
      <div class="box-wrap1">
        <div class="close" @click="closeClick">X</div>
        <div class="area">
          <div class="area-title fontColor">{{ title }}</div>
        </div>
        <div style="padding-top: 15px  ">
          <video style="width: 100%;height:300px; object-fit: fill;  animation: slide 2s;top: 200px"
                 id="myVideo"
                 muted="" autoplay="" loop="loop" crossorigin="*" controls="">
            <source :src="monitoringVideoUrl" type="video/mp4">
          </video>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import * as Cesium from 'cesium'


export default {
  name: "DynamicLabel",
  data() {
    return {
      show: true,
      rainEffect: null,
      today: this.formatDate(new Date())
    };
  },
  computed: {
    monitoringVideoUrl() {
      return `${process.env.BASE_URL}jiankon.mp4`;
    }
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    id: {
      type: String,
      default: "001",
    },
    state: {
      type: String,
      default: "001",
    },
    viewer: {}
  },
  methods: {
    closeClick() {
      if (this.id == 4) {
        let nameId = [326, 359, 355, 353, 351, 349, 347, 345, 343, 342, 341, 340, 339, 338, 337, 336, 335, 334, 333, 332, 331, 330, 329, 325, 274, 273, 271, 270, 269]
        nameId.forEach(e => {
          Hightlightline(e);
        })
      }
      if (this.closeEvent) {
        this.closeEvent();
      }


    },
    formatDate(date) {
      // 格式化成 YYYY-MM-DD
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}-${m}-${d}`;
    },
    flyReservoir() {
      this.viewer.scene.camera.flyTo({
        // 摄像头的位置
        destination: Cesium.Cartesian3.fromDegrees(110.133908, 38.746967, 2630.7572019421),
        orientation: {
          heading: 4.480692194922327,
          pitch: -0.3503734947411661,
          roll: 6.279791174058969
        }
      });
      this.closeClick()
      Hightlightline(4)
      Hightlightline(4)
    }
  }
};
</script>


<style scoped lang="scss">
.box {
  width: 250px;
  position: relative;
  bottom: 0;
  left: 0;
}

.close {
  position: absolute;
  color: #fff;
  top: 1px;
  right: 10px;
  text-shadow: 2px 2px 2px #022122;
  cursor: pointer;
  animation: fontColor 1s;
}

.box-wrap {
  position: absolute;
  left: 21%;
  top: 0;
  width: 100%;
  height: 263px;
  border-radius: 50px 0px 50px 0px;
  border: 1px solid #38e1ff;
  background-color: #38e1ff4a;
  box-shadow: 0 0 10px 2px #29baf1;
  animation: slide 2s;
}

.box-wrap1 {
  position: absolute;
  width: 400px;
  height: 350px;
  border: 1px solid #38e1ff;
  background-color: #38e1ff4a;
  box-shadow: 0 0 10px 2px #29baf1;
}

.box-wrap .area {
  position: absolute;
  top: 20px;
  right: 0;
  width: 95%;
  height: 30px;
  background-image: linear-gradient(to left, #4cdef9, #4cdef96b);
  border-radius: 30px 0px 0px 0px;
  animation: area 1s;
}

.pine {
  position: absolute;
  // left: 0;
  // bottom: -83px;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  line-height: 120px;
  text-indent: 5px;
}

.pine::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -83px;
  width: 40%;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid #38e1ff;
  transform-origin: bottom center;
  transform: rotateZ(135deg) scale(1.5);
  animation: slash 0.5s;
  filter: drop-shadow(1px 0px 2px #03abb4);
  /* transition: slash 2s; */
}

.area .area-title {
  text-align: center;
  line-height: 30px;
}

.textColor {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 1px 1px 5px #002520d2;
  animation: fontColor 1s;
}

.yellowColor {
  font-size: 14px;
  font-weight: 600;
  color: #f09e28;
  text-shadow: 1px 1px 5px #002520d2;
  animation: fontColor 1s;
}

.fontColor {
  font-size: 16px;
  font-weight: 800;
  color: #ffffff;
  text-shadow: 1px 1px 5px #002520d2;
  animation: fontColor 1s;
}

.content {
  padding: 55px 10px 10px 10px;
}

.content .data-li {
  display: flex;
}

@keyframes fontColor {
  0% {
    color: #ffffff00;
    text-shadow: 1px 1px 5px #00252000;
  }
  40% {
    color: #ffffff00;
    text-shadow: 1px 1px 5px #00252000;
  }
  100% {
    color: #ffffff;
    text-shadow: 1px 1px 5px #002520d2;
  }
}

@keyframes slide {
  0% {
    border: 1px solid #38e1ff00;
    background-color: #38e1ff00;
    box-shadow: 0 0 10px 2px #29baf100;
  }

  100% {
    border: 1px solid #38e1ff;
    background-color: #38e1ff4a;
    box-shadow: 0 0 10px 2px #29baf1;
  }
}

@keyframes area {
  0% {
    width: 0%;
  }
  25% {
    width: 0%;
  }

  100% {
    width: 95%;
  }
}

/* img{
            position:absolute;
            left:30%;
            top:0;
            width: 100%;
            box-shadow: 0 0 10px 2px #29baf1;
        } */

@keyframes slash {
  0% {
    transform: rotateZ(135deg) scale(0);
  }

  100% {
    transform: rotateZ(135deg) scale(1.5);
  }
}
</style>
